// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsights_container__eZ7L0"};